import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — near floor-to-ceiling glazing in a wall segment: the sill
// sits at 0.15 m and the head at 2.3 m, one tall glass pane in a thin matte
// frame with a slender transom bar for scale.
const PLASTER = "#e8e4dc";
const BLACK = "#2e2e30";
const GLASS = "#9fc4d4";

export const wallWindowTall = defineModel({
  id: "wall-window-tall",
  batchId: "modern",
  name: "Wall with tall window",
  tags: ["modern", "interior", "outdoor", "structure", "wall", "window", "glazing"],
  summary: "Near floor-to-ceiling glazing: sill at 0.15 m, head at 2.3 m.",
  description:
    "A one-tile wall of the Modern Living kit with near floor-to-ceiling " +
    "glazing: sill at 0.15 m, head at 2.3 m, a tall glass pane in a thin " +
    "matte-black frame with a slender transom bar. Same 0.12 m thickness " +
    "and 2.6 m height as wall-plain.",
  tiles: { w: 1, h: 1 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // low plinth below the sill (0 -> 0.15)
      { geometry: new THREE.BoxGeometry(1.0, 0.15, 0.12), color: PLASTER, position: [0, 0.075, 0] },
      // wall above the head (2.3 -> 2.6)
      { geometry: new THREE.BoxGeometry(1.0, 0.3, 0.12), color: PLASTER, position: [0, 2.45, 0] },
      // jambs at both sides of the opening
      { geometry: new THREE.BoxGeometry(0.09, 2.15, 0.12), color: PLASTER, position: [-0.455, 1.225, 0] },
      { geometry: new THREE.BoxGeometry(0.09, 2.15, 0.12), color: PLASTER, position: [0.455, 1.225, 0] },
      // thin matte frame filling the opening
      { geometry: new THREE.BoxGeometry(0.82, 2.15, 0.06), color: BLACK, position: [0, 1.225, 0] },
      // tall glass pane, slightly thicker than the frame so it shows on both faces
      { geometry: new THREE.BoxGeometry(0.74, 2.05, 0.09), color: GLASS, position: [0, 1.225, 0] },
      // slender transom bar across the glass
      { geometry: new THREE.BoxGeometry(0.74, 0.04, 0.1), color: BLACK, position: [0, 1.225, 0] },
    ];
  },
  animations: [],
});
